<div class="dashboard-toolbar">
  @if (layoutMessage) { <span class="dashboard-message" role="status">{{ layoutMessage }}</span> }
  @if (savingLayout) { <span class="text-secondary small"><span class="spinner-border spinner-border-sm me-1"></span>Saving…</span> }
  @if (editable) {
    <button type="button" class="btn btn-sm btn-pill btn-icon dashboard-edit" (click)="toggleEditMode()" [attr.aria-pressed]="editMode" title="Customize dashboard" aria-label="Customize dashboard">
      @if (editMode) {
        <svg viewBox="0 0 24 24" class="icon" aria-hidden="true"><path d="m5 12 5 5L20 7" /></svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-settings"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /></svg>
      }
    </button>
  }
</div>

@if (loadingLayout) {
  <div class="dashboard-loading"><span class="spinner-border"></span><span>Loading dashboard…</span></div>
} @else {
  <div class="dashboard-grid" role="region" aria-label="Dashboard widgets" [style.min-height]="gridMinHeight" [style.--dashboard-columns]="columns" [style.--dashboard-gap.px]="gap" [style.--dashboard-unit.px]="unit">
    @for (cell of emptyCells; track cell.x + ':' + cell.y) {
      <button
        type="button"
        class="dashboard-empty-cell"
        [style.grid-column]="(cell.x + 1) + ' / span 1'"
        [style.grid-row]="(cell.y + 1) + ' / span 1'"
        (click)="openPicker(cell)"
        [attr.aria-label]="'Add widget at column ' + (cell.x + 1) + ', row ' + (cell.y + 1)"
      >+</button>
    }

    @for (widget of widgets; track widget.id) {
      <app-dashboard-grid-item
        [placement]="widget"
        [limits]="definitionFor(widget).limits"
        [editMode]="editMode"
        [unit]="unit"
        [gap]="gap"
        (placementChange)="updateWidget($event)"
        (remove)="removeWidget(widget.id)"
      >
        <ng-container *ngComponentOutlet="componentFor(widget); inputs: inputsFor(widget)"></ng-container>
      </app-dashboard-grid-item>
    }
  </div>
}

@if (pickerOpen) {
  <button type="button" class="dashboard-drawer-backdrop" aria-label="Close widget picker" (click)="closePicker()"></button>
  <aside class="dashboard-drawer" role="dialog" aria-modal="true" aria-labelledby="dashboard-widget-picker-title">
    <div class="dashboard-drawer__header">
      <div>
        <div class="page-pretitle">Dashboard library</div>
        <h2 id="dashboard-widget-picker-title" class="h3 mb-0">Add a widget</h2>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="closePicker()"></button>
    </div>
    <div class="dashboard-drawer__body">
      <label class="input-icon widget-search">
        <span class="input-icon-addon"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg></span>
        <input type="search" class="form-control" [(ngModel)]="widgetSearch" placeholder="Search widgets" aria-label="Search widgets" />
      </label>
      <div class="widget-choice-grid">
      @for (definition of filteredDefinitions; track definition.widgetId) {
        <button type="button" class="widget-choice" (click)="addWidget(definition)">
          <span class="widget-choice__preview"><app-dashboard-widget-preview [definition]="definition"></app-dashboard-widget-preview></span>
          <span class="widget-choice__copy">
            <strong>{{ definition.name }}</strong>
            <small>{{ definition.description }}</small>
            <span class="badge bg-primary-lt">{{ definition.template }}</span>
          </span>
        </button>
      } @empty {
        <div class="empty py-5"><p class="empty-title">No widgets match “{{ widgetSearch }}”.</p></div>
      }
      </div>
    </div>
    <div class="dashboard-drawer__footer">
      <button type="button" class="btn btn-outline-secondary" (click)="resetToDefaults(); closePicker()">Restore defaults</button>
    </div>
  </aside>
}
